import React, { useState, useEffect } from 'react';
import apiCall from '../helper/apiCall';
import { toast } from 'react-toastify';
import Spinner from './Spinner';

// const ShipmentModal = ({ showModal, onClose, onUpdate, shipmentData }) => {
//     const [shipmentDate, setShipmentDate] = useState('');
//     const [shipmentCost, setShipmentCost] = useState('');
//     const [trackingNumber, setTrackingNumber] = useState('');
//     const [shippingStatus, setShippingStatus] = useState('');
//     const [shippingStatuses, setShippingStatuses] = useState([]);
//     const [statusLoading, setStatusLoading] = useState(false);

//     // Fetch shipping statuses when the modal opens
//     useEffect(() => {
//         if (showModal) {
//             const fetchShippingStatuses = async () => {
//                 setStatusLoading(true);
//                 try {
//                     const response = await apiCall("getShippingStatuses");
//                     if (response?.success) {
//                         setShippingStatuses(response.data);
//                     } else {
//                         console.error("Failed to fetch shipping statuses:", response?.message);
//                     }
//                 } catch (error) {
//                     console.error("Failed to fetch shipping statuses:", error);
//                 } finally {
//                     setStatusLoading(false);
//                 }
//             };
//             fetchShippingStatuses();
//         }
//     }, [showModal]);

//     // Pre-populate form fields when shipmentData is updated
//     useEffect(() => {
//         if (shipmentData) {
//             setShipmentDate(shipmentData.shipping_date || '');
//             setShipmentCost(shipmentData.shipping_cost || '');
//             setTrackingNumber(shipmentData.shipping_tracking_number || '');
//             setShippingStatus(shipmentData.shipping_status_id || '');
//         }
//     }, [shipmentData]);

//     if (!showModal) {
//         return null;
//     }

//     const getTodayDate = () => {
//         const today = new Date();
//         const year = today.getFullYear();
//         const month = (today.getMonth() + 1).toString().padStart(2, '0');
//         const day = today.getDate().toString().padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     };

//     const handleShipmentCostChange = (e) => {
//         const value = e.target.value;
//         if (/^\d*\.?\d*$/.test(value)) {
//             setShipmentCost(value);
//         }
//     };

//     const handleUpdate = () => {
//         const updatedData = {
//             shipment_id: shipmentData.shipment_id,
//             shipping_date: shipmentDate,
//             shipping_cost: shipmentCost,
//             shipping_tracking_number: trackingNumber,
//             shipping_status_id: shippingStatus
//         };
//         onUpdate(updatedData);
//     };

//     return (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
//             <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-xl">
//                 <h3 className="text-2xl font-bold mb-6 text-center text-gray-800">Update Shipment Details</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     {/* Shipment Date */}
//                     <div>
//                         <label htmlFor="shipment-date" className="block text-sm font-medium text-gray-700">Shipment Date</label>
//                         <input
//                             type="date"
//                             id="shipment-date"
//                             value={shipmentDate}
//                             onChange={(e) => setShipmentDate(e.target.value)}
//                             max={getTodayDate()}
//                             className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                         />
//                     </div>
//                     {/* Shipment Cost */}
//                     <div>
//                         <label htmlFor="shipment-cost" className="block text-sm font-medium text-gray-700">Shipment Cost</label>
//                         <input
//                             type="text"
//                             id="shipment-cost"
//                             value={shipmentCost}
//                             onChange={handleShipmentCostChange}
//                             className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                         />
//                     </div>
//                     {/* Tracking Number */}
//                     <div className="md:col-span-2">
//                         <label htmlFor="tracking-number" className="block text-sm font-medium text-gray-700">Tracking Number</label>
//                         <input
//                             type="text"
//                             id="tracking-number"
//                             value={trackingNumber}
//                             onChange={(e) => setTrackingNumber(e.target.value)}
//                             className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                         />
//                     </div>
//                     {/* Shipping Status */}
//                     <div className="md:col-span-2">
//                         <label htmlFor="shipping-status" className="block text-sm font-medium text-gray-700">Shipping Status</label>
//                         {statusLoading ? (
//                             <div className="flex justify-center items-center h-10 mt-1">
//                                 <Spinner />
//                             </div>
//                         ) : (
//                             <select
//                                 id="shipping-status"
//                                 value={shippingStatus}
//                                 onChange={(e) => setShippingStatus(e.target.value)}
//                                 className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                             >
//                                 <option value="" disabled>Select a status</option>
//                                 {shippingStatuses.map((status) => (
//                                     <option key={status.shipping_status_id} value={status.shipping_status_id}>
//                                         {status.shipping_status_description}
//                                     </option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>
//                 </div>
//                 <div className="mt-8 flex justify-end space-x-4">
//                     <button
//                         onClick={onClose}
//                         className="px-6 py-2 bg-gray-200 text-gray-700 font-semibold rounded-md hover:bg-gray-300 transition-colors"
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         onClick={handleUpdate}
//                         className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition-colors"
//                     >
//                         Update
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// const ShipmentModal = ({ showModal, onClose, onUpdate, shipmentData }) => {
//     // State to hold form values
//     const [shipmentDate, setShipmentDate] = useState('');
//     const [shipmentCost, setShipmentCost] = useState('');
//     const [trackingNumber, setTrackingNumber] = useState('');
//     const [shippingStatus, setShippingStatus] = useState('');
//     const [estimatedShippingDate, setEstimatedShippingDate] = useState('');

//     // State for loading and statuses
//     const [shippingStatuses, setShippingStatuses] = useState([]);
//     const [statusLoading, setStatusLoading] = useState(false);
//     const [isUpdating, setIsUpdating] = useState(false);

//     // Determines if the final shipment fields should be enabled
//     const isFinalShipmentAvailable = shipmentData?.is_estimated_shipping_date_available;

//     // Fetch shipping statuses when the modal opens
//     useEffect(() => {
//         if (showModal) {
//             const fetchShippingStatuses = async () => {
//                 setStatusLoading(true);
//                 try {
//                     const response = await apiCall("getShippingStatuses");
//                     if (response?.success) {
//                         setShippingStatuses(response.data);
//                     } else {
//                         console.error("Failed to fetch shipping statuses:", response?.message);
//                         toast.error("Failed to load shipping statuses.");
//                     }
//                 } catch (error) {
//                     console.error("Failed to fetch shipping statuses:", error);
//                     toast.error("Failed to load shipping statuses due to an error.");
//                 } finally {
//                     setStatusLoading(false);
//                 }
//             };
//             fetchShippingStatuses();
//         }
//     }, [showModal]);

//     // Pre-populate form fields when shipmentData is updated
//     useEffect(() => {
//         if (shipmentData) {
//             if (isFinalShipmentAvailable) {
//                 // If final shipment details are available, populate all fields
//                 setShipmentDate(shipmentData.shipping_date || '');
//                 setShipmentCost(shipmentData.shipping_cost || '');
//                 setTrackingNumber(shipmentData.shipping_tracking_number || '');
//                 setShippingStatus(shipmentData.shipping_status_id || '');
//                 setEstimatedShippingDate(shipmentData.estimated_shipping_date || '');
//             } else {
//                 // If only an estimated date is available, set that field
//                 setEstimatedShippingDate(shipmentData.estimated_shipping_date || '');
//                 // Clear other fields to reflect they are not yet set
//                 setShipmentDate('');
//                 setShipmentCost('');
//                 setTrackingNumber('');
//                 setShippingStatus('');
//             }
//         }
//     }, [shipmentData, isFinalShipmentAvailable]);

//     if (!showModal) {
//         return null;
//     }

//     const getTodayDate = () => {
//         const today = new Date();
//         const year = today.getFullYear();
//         const month = (today.getMonth() + 1).toString().padStart(2, '0');
//         const day = today.getDate().toString().padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     };

//     const handleShipmentCostChange = (e) => {
//         const value = e.target.value;
//         if (/^\d*\.?\d*$/.test(value)) {
//             setShipmentCost(value);
//         }
//     };

//     const handleUpdate = async () => {
//         setIsUpdating(true);
//         const updatedData = {
//             shipment_id: shipmentData.shipment_id,
//         };

//         if (isFinalShipmentAvailable) {
//             // Include all fields if the final shipment is being updated
//             updatedData.shipping_date = shipmentDate;
//             updatedData.shipping_cost = shipmentCost;
//             updatedData.shipping_tracking_number = trackingNumber;
//             updatedData.shipping_status_id = shippingStatus;
//             updatedData.estimated_shipping_date = estimatedShippingDate;
//         } else {
//             // Only update the estimated date if that's all that's available
//             updatedData.estimated_shipping_date = estimatedShippingDate;
//         }

//         try {
//             const response = await apiCall("updateShippingDetails", updatedData);
//             if (response.success) {
//                 toast.success(response?.message || 'Shipping updated successfully.');
//                 onUpdate();
//                 onClose();
//             } else {
//                 toast.error(response?.message || 'Failed to update shipping.');
//             }
//         } catch (error) {
//             console.error("Update failed:", error);
//             toast.error('An error occurred during the update.');
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     return (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
//             <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-xl">
//                 <h3 className="text-2xl font-bold mb-6 text-center text-gray-800">Update Shipment Details</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

//                     {/* Display estimated date whether it's the only field or not */}
//                     <div>
//                         <label htmlFor="estimated-shipping-date" className="block text-sm font-medium text-gray-700">Estimated Shipping Date</label>
//                         <input
//                             type="date"
//                             id="estimated-shipping-date"
//                             value={estimatedShippingDate}
//                             onChange={(e) => setEstimatedShippingDate(e.target.value)}
//                             disabled={isFinalShipmentAvailable}
//                             className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm sm:text-sm ${isFinalShipmentAvailable ? 'bg-gray-100 text-gray-500' : 'border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500'}`}
//                         />
//                     </div>

//                     {isFinalShipmentAvailable && (
//                         <>
//                             {/* Shipment Date */}
//                             <div>
//                                 <label htmlFor="shipment-date" className="block text-sm font-medium text-gray-700">Shipment Date</label>
//                                 <input
//                                     type="date"
//                                     id="shipment-date"
//                                     value={shipmentDate}
//                                     onChange={(e) => setShipmentDate(e.target.value)}
//                                     max={getTodayDate()}
//                                     className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                                 />
//                             </div>
//                             {/* Shipment Cost */}
//                             <div>
//                                 <label htmlFor="shipment-cost" className="block text-sm font-medium text-gray-700">Shipment Cost</label>
//                                 <input
//                                     type="text"
//                                     id="shipment-cost"
//                                     value={shipmentCost}
//                                     onChange={handleShipmentCostChange}
//                                     className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                                 />
//                             </div>
//                             {/* Tracking Number */}
//                             <div className="md:col-span-2">
//                                 <label htmlFor="tracking-number" className="block text-sm font-medium text-gray-700">Tracking Number</label>
//                                 <input
//                                     type="text"
//                                     id="tracking-number"
//                                     value={trackingNumber}
//                                     onChange={(e) => setTrackingNumber(e.target.value)}
//                                     className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                                 />
//                             </div>
//                             {/* Shipping Status */}
//                             <div className="md:col-span-2">
//                                 <label htmlFor="shipping-status" className="block text-sm font-medium text-gray-700">Shipping Status</label>
//                                 {statusLoading ? (
//                                     <div className="flex justify-center items-center h-10 mt-1">
//                                         <Spinner />
//                                     </div>
//                                 ) : (
//                                     <select
//                                         id="shipping-status"
//                                         value={shippingStatus}
//                                         onChange={(e) => setShippingStatus(e.target.value)}
//                                         className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                                     >
//                                         <option value="" disabled>Select a status</option>
//                                         {shippingStatuses.map((status) => (
//                                             <option key={status.shipping_status_id} value={status.shipping_status_id}>
//                                                 {status.shipping_status_description}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 )}
//                             </div>
//                         </>
//                     )}
//                 </div>
//                 <div className="mt-8 flex justify-end space-x-4">
//                     <button
//                         onClick={onClose}
//                         className="px-6 py-2 bg-gray-200 text-gray-700 font-semibold rounded-md hover:bg-gray-300 transition-colors"
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         onClick={handleUpdate}
//                         disabled={isUpdating}
//                         className={`px-6 py-2 bg-blue-600 text-white font-semibold rounded-md transition-colors ${isUpdating ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
//                     >
//                         {isUpdating ? 'Updating...' : 'Update'}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };
const ModalMessage = ({ message, type }) => {
    if (!message) return null;
    const color = type === 'error' ? 'text-red-600' : 'text-green-600';
    return (
        <div className={`text-center my-4 p-2 rounded-md ${color} bg-opacity-20`}>
            {message}
        </div>
    );
};

const ShipmentModal = ({ showModal, onClose, onUpdate, shipmentData }) => {
    // State to hold form values for various shipment details
    const [shipmentDate, setShipmentDate] = useState('');
    const [shipmentCost, setShipmentCost] = useState('');
    const [trackingNumber, setTrackingNumber] = useState('');
    const [shippingStatus, setShippingStatus] = useState('');
    const [estimatedShippingDate, setEstimatedShippingDate] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [message, setMessage] = useState(null); // State for displaying messages
    const [courierId, setCourierId] = useState('');
    // State for loading indicators and status options
    const [shippingStatuses, setShippingStatuses] = useState([]);
    const [statusLoading, setStatusLoading] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [courierNames, setCourierNames] = useState([]);
    // Determines which fields to show based on the selected shipping status.
    const showFinalShipmentFields = parseInt(shippingStatus, 10) === 12;
    const showDeliveryDateField = parseInt(shippingStatus, 10) === 4;

    // Fetch shipping statuses from the API when the modal opens.
    // useEffect(() => {
    //     if (showModal) {
    //         const fetchShippingStatuses = async () => {
    //             setStatusLoading(true);
    //             setMessage(null);
    //             try {
    //                 const response = await apiCall("getShippingStatuses");
    //                 if (response?.success) {
    //                     setShippingStatuses(response.data);
    //                 } else {
    //                     console.error("Failed to fetch shipping statuses:", response?.message);
    //                     setMessage({ text: "Failed to load shipping statuses.", type: "error" });
    //                 }
    //             } catch (error) {
    //                 console.error("Failed to fetch shipping statuses:", error);
    //                 setMessage({ text: "Failed to load shipping statuses due to an error.", type: "error" });
    //             } finally {
    //                 setStatusLoading(false);
    //             }
    //         };
    //         fetchShippingStatuses();
    //     }
    // }, [showModal]);

    useEffect(() => {
        if (showModal) {
            const fetchInitialData = async () => {
                setStatusLoading(true);
                setMessage(null);
                try {
                    // Fetching both in parallel for efficiency
                    const [statusRes, courierRes] = await Promise.all([
                        apiCall("getShippingStatuses"),
                        apiCall("getCourierNames") // Updated to your API name
                    ]);

                    if (statusRes?.success) setShippingStatuses(statusRes.data);
                    if (courierRes?.success) setCourierNames(courierRes.data);
                    
                } catch (error) {
                    console.error("Failed to fetch initial data:", error);
                    setMessage({ text: "Failed to load dropdown options.", type: "error" });
                } finally {
                    setStatusLoading(false);
                }
            };
            fetchInitialData();
        }
    }, [showModal]);
    // Pre-populate form fields when shipmentData is received or updated.
    useEffect(() => {
        if (shipmentData) {
            setShipmentDate(shipmentData.shipping_date || '');
            setShipmentCost(shipmentData.shipping_cost || '');
            setTrackingNumber(shipmentData.shipping_tracking_number || '');
            setShippingStatus(shipmentData.shipping_status_id || '');
            setEstimatedShippingDate(shipmentData.estimated_shipping_date || '');
            setDeliveryDate(''); // Clear on new data load
            setCourierId(shipmentData.courier_id || '');
        }
    }, [shipmentData]);

    if (!showModal) {
        return null;
    }

    // Utility function to get today's date in YYYY-MM-DD format for date input max attribute.
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const day = today.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Handler for shipment cost input to only allow valid decimal numbers.
    const handleShipmentCostChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setShipmentCost(value);
        }
    }; 

    // Handles the update action, including validation and API call.
    const handleUpdate = async () => {
        const statusId = parseInt(shippingStatus, 10);
        
        // Validation logic based on the selected status
        if (statusId === 12) {
            if (!shipmentDate || !shipmentCost || !trackingNumber || !courierId) {
                setMessage({ text: "Shipment Date, Cost, and Tracking Number, courier name are required for this status.", type: "error" });
                return;
            }
        }
        
        if (statusId === 4) {
            if (!deliveryDate) {
                setMessage({ text: "Delivery Date is required for this status.", type: "error" });
                return;
            }
        }

        setIsUpdating(true);
        setMessage(null);

        const updatedData = {
            shipment_id: shipmentData.shipment_id,
            shipping_status_id: statusId,
            order_number: shipmentData?.orderDetail?.order_number,
            shipment_sms_send: shipmentData?.shipment_sms_send,
            shipment_email_send: shipmentData?.shipment_email_send,
            shipment_delivered_sms_send: shipmentData?.shipment_delivered_sms_send,
            shipment_delivered_email_send: shipmentData?.shipment_delivered_email_send
        };

        // Conditionally add fields to the update payload
        if (statusId === 12) {
            updatedData.shipping_date = shipmentDate;
            updatedData.shipping_cost = shipmentCost;
            updatedData.shipping_tracking_number = trackingNumber;
            updatedData.courier_id = courierId; 
        } else if (statusId === 4) {
            updatedData.delivery_date = deliveryDate;
        }

        try {
            const response = await apiCall("updateShippingDetails", updatedData);
            if (response.success) {
                setMessage({ text: response?.message || 'Shipping updated successfully.', type: "success" });
                onUpdate();
                onClose();
            } else {
                setMessage({ text: response?.message || 'Failed to update shipping.', type: "error" });
            }
        } catch (error) {
            console.error("Update failed:", error);
            setMessage({ text: 'An error occurred during the update.', type: "error" });
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-xl">
                <h3 className="text-2xl font-bold mb-6 text-center text-gray-800">Update Shipment Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    {/* Shipping Status Dropdown (Always visible) */}
                    <div className="md:col-span-2">
                        <label htmlFor="shipping-status" className="block text-sm font-medium text-gray-700">Shipping Status</label>
                        {statusLoading ? (
                            <div className="flex justify-center items-center h-10 mt-1">
                                <Spinner />
                            </div>
                        ) : (
                            <select
                                id="shipping-status"
                                value={shippingStatus}
                                onChange={(e) => {
                                    setShippingStatus(e.target.value);
                                    setMessage(null); // Clear message on status change
                                }}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            >
                                <option value="" disabled>Select a status</option>
                                {shippingStatuses.map((status) => (
                                    <option key={status.shipping_status_id} value={status.shipping_status_id}>
                                        {status.shipping_status_description}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                    
                    {/* Conditional Fields for Shipping Status 12 */}
                    {showFinalShipmentFields && (
                        <>
                            {/* Estimated Shipping Date */}
                            <div>
                                <label htmlFor="estimated-shipping-date" className="block text-sm font-medium text-gray-700">Estimated Shipping Date</label>
                                <input
                                    type="date"
                                    id="estimated-shipping-date"
                                    value={estimatedShippingDate}
                                    onChange={(e) => setEstimatedShippingDate(e.target.value)}
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                            </div>
                            {/* Shipment Date */}
                            <div>
                                <label htmlFor="shipment-date" className="block text-sm font-medium text-gray-700">Shipment Date</label>
                                <input
                                    type="date"
                                    id="shipment-date"
                                    value={shipmentDate}
                                    onChange={(e) => setShipmentDate(e.target.value)}
                                    max={getTodayDate()}
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                            </div>
                            {/* Shipment Cost */}
                            <div>
                                <label htmlFor="shipment-cost" className="block text-sm font-medium text-gray-700">Shipment Cost</label>
                                <input
                                    type="text"
                                    id="shipment-cost"
                                    value={shipmentCost}
                                    onChange={handleShipmentCostChange}
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                            </div>
                            {/* Courier Dropdown */}
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700">Courier Name</label>
                                <select
                                    value={courierId}
                                    onChange={(e) => setCourierId(e.target.value)}
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                >
                                    <option value="">Select Courier</option>
                                    {courierNames.map((c) => (
                                        <option key={c.courier_id} value={c.courier_id}>{c.courier_name}</option>
                                    ))}
                                </select>
                            </div>
                            {/* Tracking Number */}
                            <div className="md:col-span-2">
                                <label htmlFor="tracking-number" className="block text-sm font-medium text-gray-700">Tracking Number</label>
                                <input
                                    type="text"
                                    id="tracking-number"
                                    value={trackingNumber}
                                    onChange={(e) => setTrackingNumber(e.target.value)}
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                            </div>
                        </>
                    )}

                    {/* Conditional Field for Shipping Status 4 */}
                    {showDeliveryDateField && (
                        <div className="md:col-span-2">
                            <label htmlFor="delivery-date" className="block text-sm font-medium text-gray-700">Delivery Date</label>
                            <input
                                type="date"
                                id="delivery-date"
                                value={deliveryDate}
                                onChange={(e) => setDeliveryDate(e.target.value)}
                                max={getTodayDate()}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                    )}
                </div>
                
                <ModalMessage message={message?.text} type={message?.type} />

                {/* Action Buttons */}
                <div className="mt-8 flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 bg-gray-200 text-gray-700 font-semibold rounded-md hover:bg-gray-300 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleUpdate}
                        disabled={isUpdating}
                        className={`px-6 py-2 bg-blue-600 text-white font-semibold rounded-md transition-colors ${isUpdating ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
                    >
                        {isUpdating ? 'Updating...' : 'Update'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShipmentModal;